import { Component, ElementRef, ViewContainerRef, Renderer2, Injector, ChangeDetectionStrategy, QueryList, ValueProvider } from '@angular/core';
import { ComponentBase, ComponentMixins, IComponentBase, applyMixins, PropertyCollectionInfo, setValue } from '@syncfusion/ej2-angular-base';
import { Sidebar } from '@syncfusion/ej2-navigations';



export const /** @type {?} */ inputs: string[] = ['animate','closeOnDocumentClick','dockSize','enableDock','enableGestures','enablePersistence','enableRtl','height','isOpen','locale','mediaQuery','position','showBackdrop','target','type','width','zIndex'];
export const /** @type {?} */ outputs: string[] = ['change','close','created','destroyed','open','isOpenChange'];
export const /** @type {?} */ twoWays: string[] = ['isOpen'];
/**
 * Represents the Essential JS 2 Angular Sidebar Component.
 * ```html
 * <ejs-sidebar></ejs-sidebar>
 * ```
 */
@ComponentMixins([ComponentBase])
export class SidebarComponent extends Sidebar implements IComponentBase {
public containerContext : any;
public tagObjects: any;
public isOpenChange: any;
/**
 * @param {?} ngEle
 * @param {?} srenderer
 * @param {?} viewContainerRef
 * @param {?} injector
 */
constructor(private ngEle: ElementRef,
private srenderer: Renderer2,
private viewContainerRef:ViewContainerRef,
private injector: Injector) {
        super();
        this.element = this.ngEle.nativeElement;
        this.injectedModules = this.injectedModules || [];

        this.registerEvents(outputs);
        this.addTwoWay.call(this, twoWays);
        setValue('currentInstance', this, this.viewContainerRef);
        this.containerContext  = new ComponentBase();
    }
/**
 * @return {?}
 */
public ngOnInit() {
        this.containerContext.ngOnInit(this);
    }
/**
 * @return {?}
 */
public ngAfterViewInit(): void {
        this.containerContext.ngAfterViewInit(this);
    }
/**
 * @return {?}
 */
public ngOnDestroy(): void {
        this.containerContext.ngOnDestroy(this);
    }
/**
 * @return {?}
 */
public ngAfterContentChecked(): void {
        
        this.containerContext.ngAfterContentChecked(this);
    }
public registerEvents: (eventList: string[]) => void;
public addTwoWay: (propList: string[]) => void;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'ejs-sidebar',
    inputs: inputs,
    outputs: outputs,
    template: `<ng-content ></ng-content>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    queries: {

    }
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
{type: ViewContainerRef, },
{type: Injector, },
];
}

function SidebarComponent_tsickle_Closure_declarations() {
/** @type {?} */
SidebarComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SidebarComponent.ctorParameters;
/** @type {?} */
SidebarComponent.prototype.containerContext;
/** @type {?} */
SidebarComponent.prototype.tagObjects;
/** @type {?} */
SidebarComponent.prototype.isOpenChange;
/** @type {?} */
SidebarComponent.prototype.registerEvents;
/** @type {?} */
SidebarComponent.prototype.addTwoWay;
/** @type {?} */
SidebarComponent.prototype.ngEle;
/** @type {?} */
SidebarComponent.prototype.srenderer;
/** @type {?} */
SidebarComponent.prototype.viewContainerRef;
/** @type {?} */
SidebarComponent.prototype.injector;
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
